module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x5.59237f23.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x5.png
// module id = 2772
// module chunks = 11